"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Dashboard_1 = __importDefault(require("./Dashboard"));
var ProjectListStore_1 = __importDefault(require("./ProjectList/ProjectListStore"));
var ProjectListFetcher_1 = __importDefault(require("./ProjectList/ProjectListFetcher"));
var DashboardController_1 = __importDefault(require("./DashboardController"));
var SearchStore_1 = __importDefault(require("Common/Navigation/Search/SearchStore"));
var SearchService_1 = __importDefault(require("Common/Navigation/Search/SearchService"));
var OpenBrandSetup_1 = __importDefault(require("DreamCoat/BrandSetUp/OpenBrandSetup"));
var DashboardViewStore_1 = __importDefault(require("./Stores/DashboardViewStore"));
var PageResourceApiService_1 = require("./ProjectList/PageResourceApiService");
var DashboardTelemetry_1 = require("./DashboardTelemetry");
var SavedBlockLibraryViewStore_1 = __importDefault(require("Dashboard/DashboardBlockLibrary/SavedBlockLibraryViewStore"));
var DashboardFoldersViewStore_1 = require("Dashboard/Stores/DashboardFoldersViewStore");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DashboardTypes_1 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var Types_1 = require("@CommonFrontendBackend/Folders/Types");
exports.default = (function (di, mountReactComponent, make, invoke) {
    var _a;
    var apiBaseUrl = di.get("apiBaseUrl");
    var projectListFetcher = new ProjectListFetcher_1.default(apiBaseUrl, "/projects");
    var projectLimit = di.get("projectLimit");
    var projectLiveLimit = di.get("projectLiveLimit");
    var upseller = di.get("upseller");
    var projectService = di.get("projectService");
    var $state = di.get("$state");
    var usingFeature = di.get("usingFeature");
    var modal = di.get("modal");
    var isMobile = di.get("isMobile");
    var state = di.get("state");
    var userList = di.get("userList");
    var searchService = new SearchService_1.default(di.get("apiBaseUrl"));
    var searchStore = new SearchStore_1.default(searchService);
    var telemetry = di.get("telemetry");
    var user = di.get("user");
    var rolesService = di.get("rolesService");
    var rootDataStore = di.get("rootDataStore");
    var notifyUser = di.get("notifyUser");
    var uploadStore = di.get("uploadStore");
    var inviteNewUserModal = di.get("inviteNewUserModal");
    var savedBlockDataStore = di.get("savedBlockDataStore");
    var savedBlockService = di.get("savedBlockService");
    var projectAuditInspector = di.get("projectAuditInspector");
    var pageFoldersDataStore = undefined;
    pageFoldersDataStore = rootDataStore.pageFoldersDataStore;
    pageFoldersDataStore.forceFetch();
    var dashboardViewStore = pageFoldersDataStore
        ? new DashboardViewStore_1.default(rootDataStore.getPermissionsDataStore(), modal, pageFoldersDataStore)
        : new DashboardViewStore_1.default(rootDataStore.getPermissionsDataStore(), modal);
    var blockFoldersDataStore = rootDataStore.blockFoldersDataStore;
    blockFoldersDataStore.fetch();
    var savedBlocksFolderViewStore = new DashboardFoldersViewStore_1.DashboardFoldersViewStore(new kaleidoscope_1.FolderSelectionViewStore(DashboardTypes_1.SavedBlockCollection.All), blockFoldersDataStore, modal, Types_1.CollectionType.Block);
    var pageResourceApiService = new PageResourceApiService_1.PageResourceApiService(apiBaseUrl);
    var projectListStore = new ProjectListStore_1.default(projectListFetcher, projectService, di.get("projectApiService"), di.get("projectTelemetry"), user, userList, rootDataStore, notifyUser, dashboardViewStore.folderSelectionViewStore, pageResourceApiService, di.get("genericHost"), (_a = $state === null || $state === void 0 ? void 0 : $state.params) === null || _a === void 0 ? void 0 : _a.nav, modal, rootDataStore.userDataStore.useHistoryDataStore, usingFeature);
    var savedBlockLibraryViewStore = new SavedBlockLibraryViewStore_1.default(savedBlockDataStore, savedBlockService);
    var dashboardTelemetryService = new DashboardTelemetry_1.DashboardTelemetryService(telemetry);
    var viewBluePrintChildren = function (blueprint) {
        dashboardViewStore.folderSelectionViewStore.setSelectedFolder(null);
        projectListStore.setBlueprintParent(blueprint);
        dashboardTelemetryService.trackViewBlueprintChildren();
    };
    var dashboardController = new DashboardController_1.default(projectLimit, projectLiveLimit, upseller, projectService, $state, state.goToProjectAction, usingFeature, isMobile, modal, di.get("permissionsService"), invoke(OpenBrandSetup_1.default), di.get("initSubscription"), di.get("trial"), di.get("publicApiBaseUrl"), rootDataStore, telemetry, di.get("serverTelemetry"), uploadStore, di.get("apiBaseUrl"), viewBluePrintChildren, projectAuditInspector);
    return mountReactComponent(react_1.default.createElement(Dashboard_1.default, { savedBlocksFolderViewStore: savedBlocksFolderViewStore, dashboardController: dashboardController, dashboardFoldersDataStore: pageFoldersDataStore, dashboardViewStore: dashboardViewStore, inviteNewUserModal: inviteNewUserModal, modal: modal, projectListStore: projectListStore, rolesService: rolesService, rootDataStore: rootDataStore, searchStore: searchStore, telemetry: telemetry, dashboardTelemetryService: dashboardTelemetryService, user: user, usingFeature: usingFeature, viewBluePrintChildren: viewBluePrintChildren, savedBlockLibraryViewStore: savedBlockLibraryViewStore, notifyUser: notifyUser }), {
        onDestroy: function () {
            projectListStore.disposeReactions();
        },
    });
});
